<div class="blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100 ">
    <div class="col-lg-7 col-xl-8 color-bg p-0">
      <div class="p-24 h-100">
        <div
          class="align-items-center justify-content-center img-height d-none d-lg-flex"
        >
          <img src="/assets/images/backgrounds/animacion.gif" alt="login" />
        </div>
        <img
          class="img-phone"
          src="/assets/images/logos/dark-logo.png"
          alt=""
        />
      </div>
    </div>
    <div class="col-lg-5 col-xl-4 p-0">
      <div
        class="p-32 d-flex align-items-start align-items-lg-center justify-content-center h-100"
      >
        <div class="row justify-content-center w-100">
          <div class="col-lg-9 max-width-form">
            <h4 class="title-phone">Registrate</h4>
            <h4 class="title-web">Registrate en INGE!</h4>
            <form
              class="m-t-30"
              [formGroup]="form"
              (ngSubmit)="submit(form.value)"
            >
              <section class="container-form">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="firstName" />
                  <mat-hint
                    *ngIf="f['firstName'].touched && f['firstName'].invalid"
                    class="error-msg"
                  >
                    <div
                      class="text-error"
                      *ngIf="
                        f['firstName'].errors &&
                        f['firstName'].errors['required']
                      "
                    >
                      Este Campo es requerido
                    </div>
                  </mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Apellido</mat-label>
                  <input matInput formControlName="lastName" />
                  <mat-hint
                    *ngIf="f['lastName'].touched && f['lastName'].invalid"
                    class="error-msg"
                  >
                    <div
                      class="text-error"
                      *ngIf="
                        f['lastName'].errors && f['lastName'].errors['required']
                      "
                    >
                      Este Campo es requerido
                    </div>
                  </mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>RUT</mat-label>
                  <input
                    matInput
                    formControlName="userRut"
                    (blur)="inputRut()"
                    #filterName
                  />

                  <mat-hint
                    *ngIf="f['userRut'].touched && !validateRut || f['userRut']?.errors?.['incorrect'] "
                    class="error-msg m-b-16"
                  >
                    <div class="text-error">
                      <ng-container *ngIf="f['userRut']?.errors?.['incorrect']">
                        Este rut no es compatible.
                      </ng-container>
                      <ng-container *ngIf="!validateRut">
                        RUT no es persona natural.
                      </ng-container>
                    </div>
                  </mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Teléfono</mat-label>
                  <span matPrefix>+56 &nbsp;</span>
                  <input matInput formControlName="phone" />

                  <mat-hint *ngIf="f['phone'].touched" class="m-b-16 error-msg">
                    <div class="text-error">
                      <ng-container *ngIf="f['phone']?.errors?.['required']">
                        El campo es requerido
                      </ng-container>
                      <ng-container
                        *ngIf="
                          f['phone'].errors && f['phone'].errors['pattern']
                        "
                      >
                        El formato de Telefono debe ser correcto
                      </ng-container>
                    </div>
                  </mat-hint>
                </mat-form-field>
              </section>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input
                (blur)="inputEmail()"
                
                matInput formControlName="email" />
                <mat-hint
                  *ngIf="f['email'].touched && f['email'].invalid"
                  class="m-b-16 error-msg"
                >
                  <div
                    class="text-error"
                    *ngIf="f['email'].errors && f['email'].errors['required']"
                  >
                    Este Campo es requerido
                  </div>
                  <div
                    class="text-error"
                    *ngIf="f['email'].errors && f['email'].errors['pattern']"
                  >
                    El formato de Email debe ser correcto
                  </div>
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Medio de contacto preferido</mat-label>
                <mat-select #select multiple formControlName="contactType">
                  <div class="select-all">
                    <mat-checkbox
                      [(ngModel)]="allSelected"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="toggleAllSelection()"
                      >Seleccionar Todos</mat-checkbox
                    >
                  </div>
                  <mat-option
                    (click)="optionClick()"
                    *ngFor="let type of contactType"
                    [value]="type.value"
                  >
                    {{ type.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="or-border border-company">Datos <a href="login" style="text-decoration: none; color: #2a3547; cursor: text;">de</a> Empresa</div>

              <section class="container-form">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>RUT de Empresa</mat-label>
                  <input
                    matInput
                    formControlName="companyRut"
                    (blur)="inputRutCompany()"
                  />
                  <mat-hint
                    *ngIf="f['companyRut'].touched && f['companyRut'].invalid"
                    class="m-b-16 error-msg"
                  >
                    <div
                      class="text-error"
                      *ngIf="
                        f['companyRut'].errors &&
                        f['companyRut'].errors['required']
                      "
                    >
                      Este Campo es requerido
                    </div>
                  </mat-hint>
                  <mat-hint
                    *ngIf="f['companyRut'].touched && !validateRutCompany"
                    class="m-b-16 error-msg"
                  >
                    <div class="text-error">
                      El RUT ingresado no es válido. Por favor, verificalo.
                    </div>
                  </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Clave tributaria</mat-label>
                  <input
                    matInput
                    formControlName="companySiiPassword"
                    [type]="hide ? 'password' : 'text'"
                  />
                  <span
                    style="
                      border: 0px;
                      background: transparent;
                      cursor: pointer;
                      padding-right: 5px;
                    "
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                  >
                    <mat-icon>{{
                      hide ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </span>
                  <mat-hint
                    *ngIf="
                      f['companySiiPassword'].touched &&
                      f['companySiiPassword'].invalid
                    "
                    class="m-b-16 error-msg"
                  >
                    <div
                      class="text-error"
                      *ngIf="
                        f['companySiiPassword'].errors &&
                        f['companySiiPassword'].errors['required']
                      "
                    >
                      Este Campo es requerido
                    </div>
                  </mat-hint>
                </mat-form-field>
              </section>
              <!-- <re-captcha
                formControlName="captcha" siteKey="6LfEgncoAAAAABObDfendvxDlZ9yKR8FL9AwqB3q">
              </re-captcha> -->
              <!-- <div *ngIf="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)" class="invalid-feedback">
                <div *ngIf="recaptcha.errors?.['required']">This field is required.</div>
              </div> -->
              <div>* El enrolamiento debe realizarlo exlusivamente con su clave tributaria</div>
              <div class="container-checkBox">
                <mat-checkbox
                  color="primary"
                  class="margin-top"
                  formControlName="checkbox"
                ></mat-checkbox
                >Acepto los
                <a (click)="openHeaderDialog()">terminos y condiciones</a>
              </div>
              <button
                mat-flat-button
                color="primary"
                [disabled]="!form.valid || !validateRutCompany || !validateRut"
                class="w-100"
              >
                Regístrate
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
